import { render, staticRenderFns } from "./PrefixModal.vue?vue&type=template&id=cb87a414&scoped=true&"
import script from "./PrefixModal.vue?vue&type=script&lang=js&"
export * from "./PrefixModal.vue?vue&type=script&lang=js&"
import style0 from "./PrefixModal.vue?vue&type=style&index=0&id=cb87a414&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb87a414",
  null
  
)

export default component.exports